export const DEVICE_BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 1300
};

export const getDeviceType = (width) => {
  if (width <= DEVICE_BREAKPOINTS.MOBILE) {
    return 'mobile';
  }
  if (width <= DEVICE_BREAKPOINTS.TABLET) {
    return 'tablet';
  }
  return 'pc';
};

export const checkIsMobile = (width) => width <= DEVICE_BREAKPOINTS.MOBILE;
export const checkIsTablet = (width) => width <= DEVICE_BREAKPOINTS.TABLET && width > DEVICE_BREAKPOINTS.MOBILE;